import { Inject, Injectable } from '@angular/core';
import _, { result } from 'lodash'
import { MySynchEnumerationService } from './mysynch.enumeration.service';
@Injectable({
    providedIn: 'root',
})
export class MySynchViewService {


views:any = {
    Help: {
        permissionRestriction: {
            permissions: [],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    BenchmarkingInsights: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","BENCHMARKING_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    FertilityCodes: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","COMMON_SETTINGS_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    FertilityDashboard: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","FERTILITY_DASHBOARD_READ")
            ]
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        },
        requiresFarmInBeta: {
            betas:		[
              "CohortDash_Old"
            ],
          redirect: 'Login'
        }
            
    },
    CohortDetail: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","FERTILITY_DASHBOARD_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        },
        requiresFarmInBeta: {
            betas:		[
              "CohortDash_Old"
            ],
          redirect: 'Login'
        }
    },
    FertilityAnalysisDashboard: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","FERTILITY_ANALYSIS_READ")
            ]
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    KpiDashboard: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","KPI_DASHBOARD_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    Login: {
        permissionRestriction: {
            permissions: [],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    ForgotPassword: {
        permissionRestriction: {
            permissions: [],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    FarmAdmin: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","FARM_DEMOGRAPHICS_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    // BreedingCodes: {
    //     permissionRestriction: {
    //         permissions: [
    //             this.mySynchEnumSvc.getMySynchEnumeration("Permission","BREEDING_CODES_READ")   
    //         ],
    //         redirect: 'Login'
    //     },
    //     roleRestriction: {
    //         roles: [],
    //         redirect: 'Login'
    //     }
    // },
    HerdData: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","HERD_DATA_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    UserManagement: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","USER_MANAGEMENT_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    TerritoryDashboard: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","TM_DASHBOARD_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    NewFarm: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","TM_DASHBOARD_READ"),
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","NEW_FARM_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    User: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","USER_PROFILE_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    Technicians: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","TECHNICIAN_DASHBOARD_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    Sires: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","SIRE_DASHBOARD_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    Benchmarking: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","BENCHMARKING_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    BenchmarkingApp: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","BENCHMARKING_READ")
            ],
            redirect: 'Login'
        },
         roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    SpecialReports: {
        permissionRestriction: {
            permissions: [],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    // Benchmarking: {
    //     permissionRestriction: {
    //         permissions: [
    //             this.mySynchEnumSvc.getMySynchEnumeration("Permission","BENCHMARKING_READ")
    //         ],
    //         redirect: 'Login'
    //     },
    //     roleRestriction: {
    //         roles: [],
    //         redirect: 'Login'
    //     }
    // },
    Journal: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","JOURNAL_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    NewJournal: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","JOURNAL_READ"),
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","JOURNAL_UPDATE")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },JournalEdit: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","JOURNAL_READ"),
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","JOURNAL_UPDATE")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    Fertility360Dashboard: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_DASHBOARD_PUBLISHED_REPORTS_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    Fertility360Offline: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_DASHBOARD_PUBLISHED_REPORTS_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
    },
    Fertility360report: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_DASHBOARD_PUBLISHED_REPORTS_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
              
            ],
            redirect:'Login'
        }
    },
    FarmGoalManagement: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","FARM_GOAL_MANAGEMENT_READ")        
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
              
            ],
            redirect:'Login'
        }
    },
    EvaluationOverview: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_EVALUATION_TOOL_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","TERRITORY_MANAGER")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","ADMIN")
                }
                                    
            ],
            redirect:'Login'
        },
        personTypeRestriction:{
            personTypes:[],
            redirect: 'Login'
        }
    },
    SectionPage: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_EVALUATION_TOOL_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","TERRITORY_MANAGER")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","ADMIN")
                }
                                    
            ],
            redirect:'Login'
        },
        personTypeRestriction:{
            personTypes:[],
            redirect: 'Login'
        }
    },
    
    LamenessScoring: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_EVALUATION_TOOL_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","TERRITORY_MANAGER")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","ADMIN")
                }
                                    
            ],
            redirect:'Login'
        },
        personTypeRestriction:{
            personTypes:[],
            redirect: 'Login'
        }
    },
    BodyScoring: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_EVALUATION_TOOL_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","TERRITORY_MANAGER")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","ADMIN")
                }
                                    
            ],
            redirect:'Login'
        },
        personTypeRestriction:{
            personTypes:[],
            redirect: 'Login'
        }
    },
    ResultWriteReport: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_EVALUATION_TOOL_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","TERRITORY_MANAGER")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","ADMIN")
                }
                                    
            ],
            redirect:'Login'
        },
        personTypeRestriction:{
            personTypes:[],
            redirect: 'Login'
        }
    },
    ReviewDraftReport: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_EVALUATION_TOOL_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","TERRITORY_MANAGER")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","ADMIN")
                }
                                    
            ],
            redirect:'Login'
        },
        personTypeRestriction:{
            personTypes:[],
            redirect: 'Login'
        }
    },
    
    PublishedReport: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","F360_DASHBOARD_PUBLISHED_REPORTS_READ")
            ],
            redirect:'Login'
        },
        roleRestriction: {
            roles: [
             
            ],
            redirect:'Login'
        }
    },
    AdminUserManagement: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","ADMIN_USER_MANAGEMENT_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [
                {
                  roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","PARNELL_VIEWER")
                }
            ],
            redirect: 'Login' 
        }
    },
    AdminUserManagementMaint: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","ADMIN_USER_MANAGEMENT_MAINT_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [
                {
                  roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","PARNELL_VIEWER")
                }
            ],
            redirect: 'Login'
        }
    },
    FarmManagement: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","ADMIN_FARM_MANAGEMENT_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [
                {
                  roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","PARNELL_VIEWER")
                }
            ],
            redirect: 'Login'
        }
    },
    FarmManagementMaint: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","FARM_MANAGEMENT_MAINT_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [
                {
                  roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","SUPER_ADMIN")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","PARNELL_VIEWER")
                },
                {
                    roleEnum: this.mySynchEnumSvc.getMySynchEnumeration("Role","TERRITORY_MANAGER")
                }
            ],
            redirect: 'Login'
        }
     },
     EmmRetrieveShotList: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","EMM_RETRIEVE_SHOT_LIST_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [
               
            ],
            redirect: 'Login'
        },
        requiresFarmInBeta: {
          betas:		[
            "eMM"
          ],
        redirect: 'Login'
    },
    EmmFieldReports: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","FIELD_REPORTS_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [
               
            ],
            redirect: 'Login'
        },
        requiresFarmInBeta: {
          betas:		[
            "eMM"
          ],
        redirect: 'Login'
        }
    },
    },
    MultiFarmDashboard: {
       permissionRestriction: {
           permissions: [
               this.mySynchEnumSvc.getMySynchEnumeration("Permission","MULTIFARM_DASHBOARD_READ")
           ],
           redirect: 'Login'
       },
       roleRestriction: {
           roles: [],
           redirect: 'Login'
       }
    },
    MyFarmRanks: {
       permissionRestriction: {
           permissions: [
            this.mySynchEnumSvc.getMySynchEnumeration("Permission","MY_FARM_RANKS_READ")
           ],
           redirect: 'Login'
       },
       roleRestriction: {
           roles: [],
           redirect: 'Login'
       }
    },
    ConceptionDashboard: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","CONCEPTION_DASHBOARD_READ")
            ],
            redirect: 'Login'
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        }
     },
    TrendsAndTargets: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","THREE_YEAR_TRENDS_READ")
            ]
        },
        roleRestriction: {
            roles: [ ],
            redirect: 'Login'
        },
    },
    SeasonalTrends: {
        permissionRestriction: {
            permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","SEASONAL_TRENDS_READ")
            ]
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        },
    },
    FertilityCalendars: {
        permissionRestriction: {
           permissions: [
                this.mySynchEnumSvc.getMySynchEnumeration("Permission","COMMON_SETTINGS_READ")
            ],
        },
        roleRestriction: {
            roles: [],
            redirect: 'Login'
        },
    },
}
    
    
    constructor(@Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService){

    }

    getViews(){
        return this.views;
    }

}   